import { GET_AKTIVIERUNG } from '../lib/graphql/queries.ts';
import { useQuery } from '@apollo/client/react';
import { AktivierungPage } from './AktivierungPage.tsx';
import {
  faCircleExclamation,
  faLock,
} from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { SeitenHinweis } from '../components/Hinweis.tsx';
import { Outlet } from 'react-router-dom';

export function Layout() {
  const { t } = useTranslation();
  const { data, loading, error } = useQuery(GET_AKTIVIERUNG);

  if (loading) return;

  if (error || !data) {
    return (
      <SeitenHinweis
        icon={faCircleExclamation}
        art="fehler"
        titel={t('domain.e2nApi.fehler.laden.titel')}
        beschreibung={t('domain.e2nApi.fehler.laden.beschreibung')}
      />
    );
  }

  const aktivierung = data.aktivierung;

  if (aktivierung.__typename !== 'Aktivierungszustand') {
    return (
      <SeitenHinweis
        icon={faLock}
        titel={t('domain.e2nApi.fehler.keinAdmin.titel')}
        beschreibung={t('domain.e2nApi.fehler.keinAdmin.beschreibung')}
      />
    );
  }

  if (!aktivierung.aktiv) {
    return <AktivierungPage />;
  }

  return <Outlet />;
}
